import { LoadState } from "../../constants/enums";
import { IPartnerComplaintLog, IPartnerComplaintByMechanicByCity, IPartnerComplaintReport } from "./complaints.types";

export interface IAssignMechanicFormValues {
    complaint_no_v: number;
    mechanic_id_v: number;
    nodal_name_v: string;
    custom_nodal_v?: string;
    user_name?: string;
}

export interface IComplaintsState {
    complaintLog: {
        list: {
            list: IPartnerComplaintLog[];
            totalRecords: number;
            loading: LoadState;
            error: string | null;
        };
    };
    complaintByMechanicByCity: {
        list: {
            list: IPartnerComplaintByMechanicByCity[];
            totalRecords: number;
            loading: LoadState;
            error: string | null;
        };
    };
    complaintReportDetails: {
        list: {
            list: IPartnerComplaintReport[];
            totalRecords: number;
            loading: LoadState;
            error: string | null;
        };
    };
}

export const initialComplaintsState: IComplaintsState = {
    complaintLog: {
        list: {
            list: [],
            totalRecords: 0,
            loading: LoadState.NotLoaded,
            error: null,
        },
    },
    complaintByMechanicByCity: {
        list: {
            list: [],
            totalRecords: 0,
            loading: LoadState.NotLoaded,
            error: null,
        },
    },
    complaintReportDetails: {
        list: {
            list: [],
            totalRecords: 0,
            loading: LoadState.NotLoaded,
            error: null,
        },
    },
};

export interface ICloseComplaintFormValues {
    complaint_no_v: number;
    mechanic_id_v: number | null;
    service_status_v: string;
    service_status_reason_v: string;
    complaint_status_v: string;
    close_category_v: string;
    amount_v: string;
    otp_v: string; // Changed to string to hold OTP value
    remark_v: string;
    other_remark_v: string;
    additional_details_v: any[];
    additional_amount_v: number; // New field for manual remark
    complaint_vehicle_image_v: string;
}

export const getCloseComplaintInitialValues = (complaint: IPartnerComplaintLog | null): ICloseComplaintFormValues => {
    const additionalDetailsForTowing = complaint?.fault === "TOWING" ? [{ "Towing": { value: "", amount: "" } }] : [];
    return {
        complaint_no_v: complaint?.complaint_no || 0,
        mechanic_id_v: complaint?.assigned_mechanic_id || 0,
        service_status_v: "-1",
        service_status_reason_v: "",
        complaint_status_v: "-1",
        close_category_v: "",
        amount_v: "",
        otp_v: "", // Changed to string to hold OTP value
        remark_v: "",
        other_remark_v: "",
        additional_details_v: additionalDetailsForTowing,
        additional_amount_v: 0, // New field for manual remark
        complaint_vehicle_image_v: "",
    };
};

export interface ICreateMechanicFormValues {
    mechanic_name_v: string;
    contact_no_v: string;
    agreed_amount_v: number;
    nodal_v: string;
    custom_nodal_v: string;
}

export const initialMechanicValues: ICreateMechanicFormValues = {
    mechanic_name_v: "",
    contact_no_v: "",
    agreed_amount_v: 0,
    nodal_v: "",
    custom_nodal_v: "",
};

export const getAssignMechanicInitialValues = (
    selectedRow: IPartnerComplaintLog | null,
    selectedMechanic: any | null = null,
    nodal: string = "",
    mechanicId: number | null = null
): IAssignMechanicFormValues => {
    return {
        complaint_no_v: selectedRow?.complaint_no || 0,
        nodal_name_v: selectedMechanic?.nodal || nodal || "",
        mechanic_id_v:
            selectedRow?.assigned_mechanic_id ||
            mechanicId ||
            selectedMechanic?.assigned_mechanic_id ||
            -1,
        custom_nodal_v: "",
        user_name:
            (selectedRow as any)?.mechanic_name || selectedMechanic?.mechanic_name || "",
    };
};
